module.exports = __webpack_public_path__ + "static/forecrbackground-35d226808bdadfc80ad8fc1da68f8099.png";